/** Provider timeouts are retryable service failures, not bad prompts. */
export function isImageGenerationTimeout(message?: string | null): boolean {
	return /\b(timeout|timed?\s*out|504|524)\b/i.test(message ?? "");
}
